module.exports = __webpack_public_path__ + "img/Dresscode_frechdax_v3.14b30851.svg";